import React from 'react';

import { ListItemIcon, ListItemText } from '@material-ui/core';
import {
  ReorderOutlined,
  ArrowBack,
  MonetizationOnOutlined,
  Storefront,
  PersonAdd,
  HeadsetMic,
  AccountCircleOutlined,
} from '@material-ui/icons';

import { object, func, bool, string } from 'prop-types';

import { signOutUser } from '../../../../redux/utils/cookiesUser';

import { MenuItemStyled, StyledLink, MenuStyled, MenuItemExit } from './styles';

export function HeaderUserMenu({ anchorEl, setAnchorEl, isLogged, domain, anchorOrigin, transformOrigin }) {
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MenuStyled
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      getContentAnchorEl={null}
      anchorOrigin={
        anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'center',
        }
      }
      transformOrigin={
        transformOrigin || {
          vertical: 'top',
          horizontal: 'center',
        }
      }
      disableScrollLock
    >
      {isLogged && (
        <MenuItemStyled>
          <StyledLink href="/minhaconta" title="Minha conta" aria-label="Minha conta">
            <ListItemIcon>
              <AccountCircleOutlined />
            </ListItemIcon>
            <ListItemText>Minha Conta</ListItemText>
          </StyledLink>
        </MenuItemStyled>
      )}
      {isLogged && (
        <MenuItemStyled>
          <StyledLink
            href="/minhaconta/pedidos/aguardando-pagamento"
            title="Últimos pedidos"
            aria-label="Últimos pedidos"
          >
            <ListItemIcon>
              <ReorderOutlined />
            </ListItemIcon>
            <ListItemText>Meus Pedidos</ListItemText>
          </StyledLink>
        </MenuItemStyled>
      )}
      {isLogged && (
        <MenuItemExit onClick={() => signOutUser('/', domain)}>
          <ListItemIcon>
            <ArrowBack />
          </ListItemIcon>
          <ListItemText>Sair</ListItemText>
        </MenuItemExit>
      )}
      {!isLogged && (
        <MenuItemStyled>
          <StyledLink href="/cliente/login" title="Entrar" aria-label="Entrar">
            <ListItemIcon>
              <AccountCircleOutlined />
            </ListItemIcon>
            <ListItemText>Entrar</ListItemText>
          </StyledLink>
        </MenuItemStyled>
      )}
      {!isLogged && (
        <MenuItemStyled>
          <StyledLink href="/cliente/cadastro" title="Cadastrar" aria-label="Cadastrar">
            <ListItemIcon>
              <PersonAdd color="action" />
            </ListItemIcon>
            <ListItemText>Cadastrar</ListItemText>
          </StyledLink>
        </MenuItemStyled>
      )}
    </MenuStyled>
  );
}

HeaderUserMenu.propTypes = {
  anchorEl: object,
  setAnchorEl: func,
  isLogged: bool,
  domain: string,
  anchorOrigin: object,
  transformOrigin: object,
};

export function HeaderMoreMenu({ anchorEl, setAnchorEl, anchorOrigin, transformOrigin }) {
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MenuStyled
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      getContentAnchorEl={null}
      anchorOrigin={
        anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'center',
        }
      }
      transformOrigin={
        transformOrigin || {
          vertical: 'top',
          horizontal: 'center',
        }
      }
      disableScrollLock
    >
      <MenuItemStyled>
        <StyledLink title="Totem" aria-label="Totem" href="/totem">
          <ListItemIcon>
            <MonetizationOnOutlined />
          </ListItemIcon>
          <ListItemText>Pagar Agora</ListItemText>
        </StyledLink>
      </MenuItemStyled>
      <MenuItemStyled>
        <StyledLink title="Lojas" aria-label="Lojas" href="/lojas">
          <ListItemIcon>
            <Storefront />
          </ListItemIcon>
          <ListItemText>Lojas</ListItemText>
        </StyledLink>
      </MenuItemStyled>
      <MenuItemStyled>
        <StyledLink title="Atendimento" aria-label="Atendimento" href="/atendimento">
          <ListItemIcon>
            <HeadsetMic />
          </ListItemIcon>
          <ListItemText>Atendimento</ListItemText>
        </StyledLink>
      </MenuItemStyled>
    </MenuStyled>
  );
}

HeaderMoreMenu.propTypes = {
  anchorEl: object,
  setAnchorEl: func,
  anchorOrigin: object,
  transformOrigin: object,
};
